'use client'

import Image from 'next/image'
import Link from 'next/link'
import React, { memo } from 'react'

interface HeroCategoryCardProps {
  imageUrl?: string
  title?: string
  description?: string
  altText?: string
  link?: string
  isLoading?: boolean
}

const HeroCategoryCard: React.FC<HeroCategoryCardProps> = ({
  imageUrl = '',
  title = '',
  description = '',
  altText = '',
  link = '',
  isLoading = false,
}) => {
  return (
    <div className="flex items-start space-x-4 py-2 border-b border-gray-300 last:border-0">
      {isLoading ? (
        // Skeleton state
        <>
          <div className="flex-shrink-0 w-[100px] h-[80px] bg-gray-300 rounded animate-pulse" />
          <div className="flex-1 space-y-2">
            <div className="h-4 bg-gray-300 rounded w-3/4 animate-pulse" />
            <div className="h-3 bg-gray-300 rounded w-full animate-pulse" />
          </div>
        </>
      ) : (
        // Normal content
        <>
          <Link href={`/${link}`} className="flex-shrink-0 w-[100px] h-[80px]">
            <Image
              title={title}
              src={`${process.env.NEXT_PUBLIC_IMAGE_URL}${imageUrl}`}
              alt={altText}
              width={100}
              height={80}
              className="w-full h-full object-cover"
              priority
              unoptimized
            />
          </Link>
          <div className="flex-1">
            <Link href={`/${link}`} title={title}>
              <h3 className="text-sm font-title font-semibold text-gray-800 hover:text-primary cursor-pointer">
                {title}
              </h3>
            </Link>
            <p className="text-xs text-gray-500 mt-1 line-clamp-2" title={title}>
              {description}
            </p>
          </div>
        </>
      )}
    </div>
  )
}

export default memo(HeroCategoryCard)
